import { Flex, Tag, Typography } from "antd";
import { DefaultOptionType } from "antd/es/select";
import { ColumnsType } from "antd/es/table";
import { t } from "i18next";
import { ColorText } from "../../../components/ColorText/ColorText";
import { FilterItem, FilterItemType } from "../../filters/filters.types";
import {
  ExciseStampRequest,
  ExciseStampRequestListPayload,
} from "./exciseStamps.types";

export const EXCISE_STAMP_INITIAL_FILTERS = {
  brojZahteva: null,
  brojMarkice: null,
  datum: null,
  vrstaProizvoda: null,
  statusZahteva: null,
};

export const getExciseStampRequestTableColumns = () => {
  const { Text } = Typography;

  return [
    {
      title: t("TABLES.BROJ_ZAHTEVA"),
      dataIndex: "brojZahteva",
      width: "120px",
    },
    { title: t("TABLES.VRSTA_PROIZVODA"), dataIndex: "vrstaProizvoda" },
    {
      title: t("TABLES.DATUM_KREIRANJA_ZAHTEVA"),
      dataIndex: "datumKreiranjaZahteva",
    },
    {
      title: t("TABLES.OPSEG"),
      dataIndex: "opsegIsporucenihMarkica",
      render: (opsezi: string[]) => (
        <Flex gap={4} align="start" vertical>
          {opsezi.map((opseg: string, index: number) => (
            <Tag key={index}>{opseg}</Tag>
          ))}
        </Flex>
      ),
    },
    {
      title: t("TABLES.STATUS"),
      dataIndex: "status",
      render: (status: string) => ColorText(status),
    },
    {
      dataIndex: "vracenNaDopunu",
      render: (vracenNaDopunu: boolean) =>
        vracenNaDopunu ? (
          <Text italic type="warning">
            {t("TABLES.DOPUNI_ZAHTEV")}
          </Text>
        ) : (
          <Text italic>{t("TABLES.VIDI_DETALJE")}</Text>
        ),
      width: "150px",
    },
  ] as ColumnsType<ExciseStampRequest>;
};

export const getExciseStampRequestFilterItems = ({
  isLoading,
  isDisabled,
  statuses,
  productTypes,
}: {
  isLoading?: boolean;
  isDisabled?: boolean;
  statuses?: Array<DefaultOptionType>;
  productTypes?: Array<DefaultOptionType>;
}): Array<FilterItem<ExciseStampRequestListPayload>> => {
  return [
    {
      fieldName: "brojZahteva",
      type: FilterItemType.TEXT,
      props: {
        placeholder: t("TABLES.BROJ_ZAHTEVA"),
        disabled: isDisabled,
      },
    },
    {
      fieldName: "vrstaProizvoda",
      type: FilterItemType.SELECT,
      props: {
        placeholder: t("TABLES.VRSTA_PROIZVODA"),
        loading: isLoading,
        options: productTypes,
        disabled: isDisabled,
      },
    },
    {
      fieldName: "brojMarkice",
      type: FilterItemType.TEXT,
      props: {
        placeholder: t("PLACEHOLDERS.BROJ_MARKICE"),
        disabled: isDisabled,
      },
    },
    {
      fieldName: "statusZahteva",
      type: FilterItemType.SELECT,
      props: {
        placeholder: t("PLACEHOLDERS.STATUS"),
        loading: isLoading,
        options: statuses,
        disabled: isDisabled,
      },
    },
    {
      fieldName: "datum",
      type: FilterItemType.DATE_RANGE,
      props: {
        placeholder: [t("PLACEHOLDERS.DATUM_OD"), t("PLACEHOLDERS.DATUM_DO")],
        disabled: isDisabled,
      },
    },
  ];
};
